// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateNginxSetting_createButton__2lrMN"};